export default __webpack_public_path__ + "static/media/etapa5.5e0f81db.png";